export interface PaginatedRequest {
  page: number;
  pageSize: number;
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
  search?: string;
}

export interface PaginatedResponse<T> {
  items: T[];
  total: number;
  page: number;
  pageSize: number;
}

export interface ApiErrorBody {
  message: string;
  code?: string;
  fieldErrors?: Record<string, string>;
}

export interface ErrorDetail {
  code: string;
  message: string;
  details?: Record<string, string>;
}

/**
 * Every backend response is wrapped in this envelope. Paginated list
 * endpoints nest a `PagedResponse<T>` inside `data` (see below).
 */
export interface ApiEnvelope<T> {
  success: boolean;
  data: T;
  error?: ErrorDetail;
  timestamp: string;
}

export interface PagedResponse<T> {
  content: T[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  last: boolean;
}

export class ApiError extends Error {
  readonly status: number;
  readonly code?: string;
  readonly fieldErrors?: Record<string, string>;

  constructor(message: string, status: number, code?: string, fieldErrors?: Record<string, string>) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.fieldErrors = fieldErrors;
  }
}
